'use client';

import PricingTabButton from '@/app/(home)/components/pricing-tab-button';
import HourlyRateCard from '@/app/pricing/components/hourly-rate-card';
import PricingCard from '@/app/pricing/components/pricing-card';
import FullWidthSection from '@/components/full-width-section';
import { usePricingList } from '@/services/query/pricing.query';
import { PricingCategoryCode } from '@/services/types/pricing.type';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

const PricingSection = () => {
  const [tab, setTab] = useState<
    PricingCategoryCode.UNLIMITED | PricingCategoryCode.TIME_LIMITED
  >(PricingCategoryCode.UNLIMITED);

  const { data: pricingList } = usePricingList();

  const unlimitedPricingList = pricingList?.data
    .filter((pricing) => pricing.code === PricingCategoryCode.UNLIMITED)
    .flatMap((pricing) => pricing.plans);

  const specialPricingList = pricingList?.data
    .filter((pricing) => pricing.code === PricingCategoryCode.SPECIAL)
    .flatMap((pricing) => pricing.plans);

  return (
    <FullWidthSection className="bg-sub-darknavy text-white">
      <div className="desktop:flex desktop:justify-center">
        <div className="desktop:web-w desktop:w-full desktop:relative">
          <div className="bg-white-rhombus-pattern transform2 desktop:h-14 desktop:right-0 desktop:w-[302px] absolute top-0 right-3 h-7.5 w-40.5"></div>
          <div className="desktop:web-w desktop:mx-auto desktop:px-0 relative w-full px-6 text-center">
            {/* 1. 섹션 타이틀 */}
            <h2 className="typo-32 desktop:typo-50 desktop:pt-30 desktop:mb-13 mb-8 pt-20 font-black">
              드라이빙존 요금 안내
            </h2>

            {/* 2. 버튼 스타일 탭 */}
            <div className="desktop:mb-13 mb-8 flex justify-center gap-2">
              <PricingTabButton
                isActive={tab === PricingCategoryCode.UNLIMITED}
                onClick={() => setTab(PricingCategoryCode.UNLIMITED)}
              >
                무제한
              </PricingTabButton>
              <PricingTabButton
                isActive={tab === PricingCategoryCode.TIME_LIMITED}
                onClick={() => setTab(PricingCategoryCode.TIME_LIMITED)}
              >
                특별반
              </PricingTabButton>
            </div>

            {/* 3. 서브 텍스트 */}
            {/* 4. 카드 그리드 */}
            {tab === PricingCategoryCode.UNLIMITED ? (
              <>
                <div className="typo-18 desktop:typo-24 desktop:leading-snug desktop:mb-14 mb-8 flex flex-col gap-1.5 leading-snug font-semibold text-white">
                  <div className="desktop:flex-row flex flex-col justify-center gap-1.5">
                    <span>
                      운전면허학원비용 대비{' '}
                      <span className="text-main-yellow">절반 가격의</span>
                    </span>
                    <span>
                      <span className="text-main-yellow">
                        '무제한반'을 추천
                      </span>
                      드려요!
                    </span>
                  </div>
                  <div className="desktop:flex-row flex flex-col justify-center gap-1.5">
                    <span>수강생 84%가 선택한 베스트셀러!</span>
                    <span>면허 취득까지 무제한 연습!</span>
                  </div>
                </div>
                <div className="desktop:grid-cols-3 grid grid-cols-1 items-center justify-center gap-7">
                  {unlimitedPricingList?.map((plan, index) => (
                    <PricingCard key={index} {...plan} />
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="typo-18 desktop:typo-24 desktop:leading-snug desktop:mb-14 mb-8 flex flex-col gap-1.5 leading-snug font-semibold text-white">
                  <div className="desktop:flex-row flex flex-col justify-center gap-1.5">
                    <span>
                      수강생의{' '}
                      <span className="text-main-yellow">
                        상황과 필요에 맞춰 꼭 필요한 부분만{' '}
                      </span>
                    </span>
                    <span>콕 집어 코칭받을 수 있는, </span>
                    <span>
                      합리적인 가격의 맞춤형{' '}
                      <span className="text-main-yellow">'특별반'!</span>
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-1 items-center justify-center gap-7">
                  {specialPricingList?.map((plan, index) => (
                    <HourlyRateCard key={index} {...plan} />
                  ))}
                </div>
              </>
            )}

            <span className="typo-14 text-level-6 desktop:typo-16 desktop:pt-7 inline-block w-full pt-4 text-right font-medium">
              * VAT 별도 금액
            </span>

            {/* 5. 자세히 보기 링크 */}
            <div className="desktop:pb-30 pt-4.5 pb-15">
              <Link href="/pricing" className="inline-flex items-center">
                <span className="typo-18 desktop:typo-24 mr-2 inline-block font-bold text-white">
                  자세히 보기
                </span>
                <Image
                  src="/images/icons/icon_arrow_right.svg"
                  alt=""
                  width={16}
                  height={16}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </FullWidthSection>
  );
};

export default PricingSection;
